import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { app } from '../firebase';
import { getDatabase, ref, onValue } from 'firebase/database';
import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api';
import './Dash.css';
import NavBar from '../Components/NavBar';
import LeftBar from '../Components/LeftBar';
import bikeIcon from '../Images/bike1.png'

const containerStyle = {
  width: '100%',
  height: '500px',
};

const defaultCenter = { lat: -1.2771472, lng: 36.8214853 }; // Nairobi

function TrackDriverPage() {
  const { uid } = useParams();
  const db = getDatabase(app);

  const [location, setLocation] = useState(defaultCenter); // animated marker position
  const [targetLocation, setTargetLocation] = useState(defaultCenter); // actual driver location

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: 'AIzaSyA297W_3urY4B_E0SbyfM_C_eqy6a6JGrY', // Replace with your Google Maps API key
  });

  console.log("Tracking driver UID:", uid);

  // Subscribe to driver's realtime location
// Subscribe to driver's realtime location
useEffect(() => {
  const driverRef = ref(db, `drivers/${uid}/lastLocation`);
  const unsubscribe = onValue(driverRef, (snapshot) => {
    const data = snapshot.val();
     console.log(data)
    if (data?.lat && data?.lng) {
      const newLoc = { lat: data.lat, lng: data.lng };
      setTargetLocation(newLoc);
      
      console.log(data)

      // If location is still default, snap marker immediately
      setLocation((prev) => {
        if (prev.lat === defaultCenter.lat && prev.lng === defaultCenter.lng) {
          return newLoc;
        }
        return prev;
      });
    }
  });
  return () => unsubscribe();
}, [db, uid]);

  // Smoothly animate marker towards targetLocation
  useEffect(() => {
    const interval = setInterval(() => {
      setLocation((prev) => {
        const latDiff = targetLocation.lat - prev.lat;
        const lngDiff = targetLocation.lng - prev.lng;

        // If marker is close enough, snap to target
        if (Math.abs(latDiff) < 0.00001 && Math.abs(lngDiff) < 0.00001) {
          return targetLocation;
        }

        // Move 20% closer to the target each step
        return {
          lat: prev.lat + latDiff * 0.2,
          lng: prev.lng + lngDiff * 0.2,
        };
      });
    }, 100); // update every 100ms

    return () => clearInterval(interval);
  }, [targetLocation]);

  if (loadError) return <p>Error loading maps</p>;
  if (!isLoaded) return <p>Loading Maps...</p>;

  return (
    <div className="contentMain">
      <LeftBar />
      <div className="theRightOne">
        <div className="DashTop">
          <h1>Track Driver</h1>
          <NavBar />
        </div>
        <div className="p-4">
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={location} // map follows driver
            zoom={15}
          >
            <Marker 
              position={location}
              icon={{
                url: bikeIcon, // place your bike image in the public folder
                scaledSize: new window.google.maps.Size(60, 60), // adjust size
                origin: new window.google.maps.Point(0, 0),
                anchor: new window.google.maps.Point(20, 20), // centers the icon
              }}
            />

          </GoogleMap>
        </div>
      </div>
    </div>
  );
}

export default TrackDriverPage;
